import { DIARY_MENU_ACTIONS } from '../../config/menu-actions-config';
import { MEAL_TYPE_MAP } from '../../config/meal-config';

const useDiaryMenuActions = ({
    openModal,
    addMeal,
    deleteFavoriteMeal,
    deletePlaceholder,
    favoriteId,
    slotIndex
}) => {
    return ({ action, entryType, mealId, displayIndex, isExercise }) => {
        const modalEntryType = isExercise ? 'exercise' : entryType;

        const open = (view, modalAction = null, payload = null) =>
            openModal({ entryType: modalEntryType, mealId }, view, modalAction, payload);

        const mealKey = MEAL_TYPE_MAP[entryType];

        switch (action) {
            case DIARY_MENU_ACTIONS.COPY:
                return open('datePicker', 'copy');

            case DIARY_MENU_ACTIONS.MOVE:
                return open('datePicker', 'move');

            case DIARY_MENU_ACTIONS.FAVORITE:
                return open('favorite');

            case DIARY_MENU_ACTIONS.UNFAVORITE:
                if (!favoriteId) return;
                return deleteFavoriteMeal(favoriteId);

            case DIARY_MENU_ACTIONS.EDIT:
                return open(isExercise ? 'editExercise' : 'editMeal', null, { payload: { slotIndex } });

            case DIARY_MENU_ACTIONS.NUTRITION:
                if (!isExercise) return open('nutrition');
                return;

            case DIARY_MENU_ACTIONS.DELETE:
                if (isExercise) {
                    return open('deleteExercise');
                }

                if (mealId === null) {
                    if (!mealKey || displayIndex == null) return;

                    deletePlaceholder(mealKey, displayIndex);
                    return;
                }

                return open('deleteMeal', null, { payload: { slotIndex } });

            case DIARY_MENU_ACTIONS.ADD_MEAL_TYPE:
                if (isExercise || !mealKey) return;

                addMeal([{ meal_id: null, kcal: 0, items: [] }], mealKey, slotIndex);
                return;

            default:
                console.warn('Unhandled diary menu action:', action);
        }
    };
};

export default useDiaryMenuActions;
